/**
 * Notification Area Component
 *
 * Displays notifications for the admin dashboard.
 * Shows alerts and action items that require attention.
 */
import React from 'react';
import './NotificationArea.css';

export interface Notification {
  id: string;
  date: string;
  time: string;
  message: string;
  OnClick?:() => void;//setting the notifications clickable
}


export interface NotificationAreaProps {  
  /** List of notifications */
  notifications?: Notification[];
  /** Callback when a notification is dismissed */
  onDismiss?: (id: string) => void;
  /** Callback when clear all button is clicked */
  onClearAll?: () => void;
}

const NotificationArea: React.FC<NotificationAreaProps> = ({
  notifications = [],
  onDismiss,
  onClearAll,
}) => {

  const displayNotifications = notifications.length >0 ? notifications : [];

  const handleDismiss = (id: string, e:React.MouseEvent)=>{
    e.stopPropagation(); // Prevent triggering onClick of the notification
    if (onDismiss) {
      onDismiss(id);
    }
  };

  return (
    <div className="notification-area">
      <div className="notification-area__container">
        <div className="notification-area__header">
          <h2 className="notification-area__title">通知</h2>
          {displayNotifications.length > 0 && (
            <button
              className="notification-area__clear-btn"
              onClick={onClearAll}
            >
              消去
            </button>
          )}
        </div>
        <div className="notification-area__list">
          {displayNotifications.map((notification, index) => (
            <div 
              key={notification.id} 
              className={`notification-area__item ${notification.OnClick ? 'notification-area__item--clickable' : ''}`}
              onClick={notification.OnClick}
              role = {notification.OnClick ? 'button' : undefined}
            >
              <div className="notification-area__number">{index + 1}</div>
              <div className="notification-area__content">
                <div className="notification-area__datetime">
                  {notification.date} {notification.time}
                </div>
                <div className="notification-area__message">
                  {notification.message}
                </div>
              </div>
              <button
                className="notification-area__dismiss"
                onClick={(e) => handleDismiss(notification.id,e)}
                aria-label="Dismiss notification"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationArea;
